// extracted by mini-css-extract-plugin
export default {"textInput":"TextInput_textInput__iqC6X"};